module.exports = "/_next/static/media/e2297eb4cce0e1d821d7f8c75adf5d6f.png";